import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19050 19718"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970278267104">
        <path d="M8097 0h2857v10193H8097z" className="fil0" />
        <path
          d="m13768 1674-1275 2557c2282 1139 3699 3423 3699 5962 0 3676-2991 6667-6667 6667s-6667-2991-6667-6667c0-2539 1417-4824 3700-5962L5282 1674C2025 3300 0 6564 0 10193c0 5252 4273 9525 9525 9525s9525-4273 9525-9525c0-3629-2024-6894-5282-8519z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
